import { render, staticRenderFns } from "./ttttt.vue?vue&type=template&id=7ace249a&scoped=true&"
import script from "./ttttt.vue?vue&type=script&lang=js&"
export * from "./ttttt.vue?vue&type=script&lang=js&"
import style0 from "./ttttt.vue?vue&type=style&index=0&id=7ace249a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ace249a",
  null
  
)

export default component.exports